export enum ItemLanguageCode {
  English = 'en'
}

export enum ContentItemLanguageId {
  English = 1
}

export enum ConferenceItemLanguageId {
  English = 7
}
